<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import EmployeesTable from "./employees-table";
import errorLoading from "@/components/error-loading";
import Multiselect from "vue-multiselect";
import {required, requiredIf,} from "vuelidate/lib/validators";
import {API} from "@/api";
import {mapActions} from 'vuex'

//const fullnameValidator = helpers.regex('alpha', /^[^\s]+( [^\s]+)+$/);

/**
 * Form-element component
 */
export default {
  page: {
    title: "Manage employees",
    meta: [{name: "description", content: appConfig.description}]
  },
  components: {Layout, PageHeader, EmployeesTable, errorLoading, Multiselect},
  data() {
    return {
      title: "Manage employees",
      items: [
        {
          text: "employees",
          href: "/"
        },
        {
          text: "Manage Employees",
          active: true
        }
      ],
      departments:[],
      employees: [],
      locations: [],
      states: [],
      countries: [],
      isError: false,
      isSuccess: false,
      isBusy: false,
      isLoading: true,
      isLoadingError: false,
      successMsg: "",
      errorMsg: "",
      status: "not_accepted",
      checkCustom: "not_accepted",
      checked: true,
      value: null,
      document: "",
      filename: "Choose File",
      fullname: "",
      phone: "",
      email: "",
      dob: "",
      staffId: "",
      department: "",
      gradelevel: "",
      designation: "",
      location: "",
      state: "",
      country: "",
      selectedEmployee: ""
    };
  },
  validations: {
    //document: {required},
    /* fullname: {required, alpha},
     staffId: {required, minLength: minLength(4)},
     phone: {required, minLength: minLength(11)},
     email: {required, email},
     dob: {required},*/
    /* gradelevel: {required},
     designation: {required},*/
    department: {required},
    location: {required},
    country: {
      required: requiredIf(function () {
        return this.location && this.location.text === 'Foreign';
      }),
    },
    state: {
      required: requiredIf(function () {
        return this.location && this.location.text === 'Local';
      }),
    }
  },
  watch: {
    location(newValue) {
      if (!newValue || newValue.text !== 'Foreign') {
        this.country = null;
      }
      if (!newValue || newValue.text !== 'Local') {
        this.state = null;
      }
    },
  },
  mounted() {
    //store.dispatch('employee/fetchEmployees')
    //this.employees = store.getters['employee/employeesList']
    //store.fetchEmployees();

    API.get("/locations/all").then(response => {
      response.data.map(loc => {
        this.locations.push({
          value: loc.id,
          text: loc.location
        })
      })

    }).catch(e => {
      this.notifyLoadingError();
      console.log(e);
    })
    API.get("/locations/countries").then(response => {
      response.data.map(item => {
        this.countries.push({
          value: item.id,
          text: item.country
        })
      })
    }).catch(e => {
      this.notifyLoadingError();
      console.log(e);
    })

    API.get("/locations/states").then(response => {
      console.clear();
      console.log(response.data);
      response.data.map(item => {
        this.states.push({
          value: item.id,
          text: item.state
        })
      })

    }).catch(e => {
      this.notifyLoadingError();
      console.log(e);
    }),

        API.get("/all-departments").then(response => {
          response.data.map(dept => {
            this.departments.push({
              value: dept.id,
              text: dept.name
            })
          })
          //this.departments = response.data;
          //console.log(response.data);
        }).catch(e => {
          this.notifyLoadingError();
          console.log(e);
        }),

    API.get("/employees").then(response => {
      this.loadComplete();
      this.employees = response.data;
      this.$router.push(
          this.$route.query.redirectFrom || {name: "Manage Employees"}
      );
    })
        .catch(e => {
          this.notifyLoadingError();
          console.log(e);

        })
  },
  methods: {
    ...mapActions(["fetchEmployees"]),
    onSelectedEmployee(employee) {
      this.selectedEmployee = employee;
      this.location = this.locations.find(loc => loc.text === employee.location) || null;
      this.country = employee.country ? this.countries.find(c => c.value === Number(employee.country)) || null : null;
      this.department = this.departments.find(dept => dept.value === Number(employee.job_trade)) || null;
      this.state = employee.state ? this.states.find(s => s.value === Number(employee.state)) || null : null;
    },

    async saveChanges() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        this.processing();
        console.clear();
        console.log(this.country);
        console.log(this.location);
        console.log(this.state);


        // Build the payload conditionally
        const payload = {
          id: this.selectedEmployee.id,
          email: this.selectedEmployee.email,
          fullname: this.selectedEmployee.fullname,
          staff_id: this.selectedEmployee.staff_id,
          department: this.selectedEmployee.department,
          grade_level: this.selectedEmployee.gradelevel,
          designation: this.selectedEmployee.designation,
          phone: this.selectedEmployee.phone,
          location: this.location.text,
          type: this.department.value,
          job_trade: this.department.value
        };

        // Conditionally add country or state
        if (this.location.text === 'Foreign') {
          if (this.country.value != null) {
            payload.country = this.country.value;
          }
        } else {
          if (this.state != null) {
            payload.state = this.state.value;
          }
        }

        await API.post("/employee/update", payload)
            .then(response => {
              this.completed();
              this.notifySuccess();
              this.showSuccess(response.data)
              console.log(response.data);
              /* this.$router.push(
                   this.$route.query.redirectFrom || {name: "M Employees"}
               );*/
            })
            .catch(e => {
              this.completed();
              this.notifyError();
              //this.showError("Oops! an error occured while processing ");
              this.showError(e.response.data);
              //this.errorMsg = e.response.data;
              console.log(e);

            })
      }
    },

    customSelector({ text }){
      return `${ text }`;
    },


  },
  computed: {
    // Map IDs to names for display
    departmentName() {
      return (id) => {
        const dept = this.departments.find(d => d.id === id);
        return dept ? dept.name : 'N/A';
      };
    },
    countryName() {
      return (id) => {
        const country = this.countries.find(c => c.id === id);
        return country ? country.name : 'N/A';
      };
    },
    stateName() {
      return (id) => {
        const state = this.states.find(s => s.id === id);
        return state ? state.name : 'N/A';
      };
    }
  },
};
</script>

<template>
  <Layout>
    <PageHeader v-if="!isLoading" :items="items" :title="title"/>
    <div v-if="!isLoading && !isLoadingError" class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <EmployeesTable :employee-data="employees" :countries="countries" :departments="departments" @onSelectedEmployee="onSelectedEmployee"/>
          </div>
        </div>
        <!-- end card -->
      </div>
    </div>
    <div v-if="isLoading && !isLoadingError" class="text-center justify-content-center mb-3">
      <b-spinner class="mt-5" role="status" style="width: 3rem; height: 3rem;" type="grow"
                 variant="primary"></b-spinner>
      <p class="text-primary">loading...</p>
    </div>
    <div v-if="isLoadingError" class="text-center justify-content-center mb-3 mt-5 m-5">
      <errorLoading/>
    </div>

    <b-modal
        id="modal-center"
        centered
        hide-footer
        size="lg"
        title="Update employee"
        title-class="font-size-12"
    >


      <div class="row">
        <div class="col-lg-1">
        </div>
        <div class="col-10">
          <PageHeader :items="items" :title="title"/>
        </div>
        <div class="col-lg-1">
        </div>
      </div>

      <b-alert v-if="isSuccess" dismissible show variant="success">{{ successMsg }}</b-alert>
      <b-alert v-if="isError" show variant="danger">{{ errorMsg }}</b-alert>

      <div class="row">
        <div class="col-lg-1">
        </div>
        <div class="col-10">
          <div class="">
            <div class="">
              <div class="card-title mb-3 text-muted"><em>Basic Information </em></div>
              <div class="row">
                <div class="col-12">
                  <form class="form-horizontal" role="form">
                    <b-form-group
                        id="fullname"
                        label="Fullname"
                        label-cols-lg="2"
                        label-cols-sm="2"
                        label-for="text"
                    >
                      <b-form-input :value="selectedEmployee.fullname" disabled for="text" readonly></b-form-input>
                    </b-form-group>

                    <b-form-group
                        id="phonenumber"
                        label="Phone"
                        label-cols-lg="2"
                        label-cols-sm="2"
                        label-for="number"
                    >
                      <b-form-input id="number" :value="selectedEmployee.phone" name="number"
                                    placeholder="e.g 0801234567890" type="number"></b-form-input>
                    </b-form-group>

                    <b-form-group
                        id="email"
                        label="Email"
                        label-cols-lg="2"
                        label-cols-sm="2"
                        label-for="email"
                    >
                      <b-form-input id="email" :value="selectedEmployee.email" disabled placeholder="e.g abc@gmail.com"
                                    readonly></b-form-input>
                    </b-form-group>

                    <b-form-group
                        id="date"
                        label="Date of Birth"
                        label-cols-lg="2"
                        label-cols-sm="2"
                        label-for="date"
                    >
                      <b-form-input id="date" :value="selectedEmployee.dob" placeholder="01/05/1987"
                                    type="date"></b-form-input>
                    </b-form-group>


                  </form>
                </div>
              </div>
              <!-- end row -->
            </div>
          </div>
          <!-- end card -->
        </div>
        <div class="col-lg-1">
        </div>
        <!-- end col -->
      </div>

      <div class="row">
        <div class="col-lg-1">
        </div>
        <div class="col-10">
          <div class="">
            <div class="">
              <div class="card-title mt-2 mb-3 "><em class="card-title mt-2 mb-3 text-muted">Official Information</em>
              </div>
              <div class="row">
                <div class="col-12">
                  <form class="form-horizontal" role="form">
                    <b-form-group
                        id="select"
                        label="Department"
                        label-cols-lg="2"
                        label-cols-sm="2"
                        label-for="type"
                    >
                      <multiselect v-model="department" :class="{ 'is-invalid':$v.department.$error }"
                                   :options="departments" @blur="$v.department.$touch()"
                                   :custom-label="customSelector"
                                   @input="$v.department.$touch()"></multiselect>
                      <div v-if="$v.department.$error" class="invalid-feedback">
                        <span v-if="!$v.department.required">Please select a department.</span>
                      </div>
                    </b-form-group>

                    <b-form-group
                        id="staffid"
                        label="Staff Id"
                        label-cols-lg="2"
                        label-cols-sm="2"
                        label-for="text"
                    >
                      <b-form-input :value="selectedEmployee.staff_id" disabled for="text" placeholder="e.g FG-TCN-002"
                                    readonly></b-form-input>
                    </b-form-group>

                    <b-form-group
                        id="Gradelevel"
                        label="Grade Lvl"
                        label-cols-lg="2"
                        label-cols-sm="2"
                        label-for="designation"
                    >
                      <b-form-input id="number" :value="selectedEmployee.gradelevel" name="designation"
                                    placeholder="e.g Gl-14"></b-form-input>
                    </b-form-group>

                    <b-form-group
                        id="designation"
                        label="Designation"
                        label-cols-lg="2"
                        label-cols-sm="2"
                        label-for="designation"
                    >
                      <b-form-input id="number" :value="selectedEmployee.designation"
                                    name="designation" placeholder="e.g Head of Procurement"></b-form-input>
                    </b-form-group>

                    <b-form-group
                        id="location"
                        label="Location"
                        label-cols-lg="2"
                        label-cols-sm="2"
                        label-for="type"
                    >
                      <multiselect v-model="location" :class="{ 'is-invalid':$v.location.$error }"
                                   :options="locations" @blur="$v.location.$touch()"
                                   :custom-label="customSelector"
                                   @input="$v.location.$touch()"></multiselect>
                      <div v-if="$v.location.$error" class="invalid-feedback">
                        <span v-if="!$v.location.required">Please select a location.</span>
                      </div>
                    </b-form-group>

                    <b-form-group
                        v-if="location.text === 'Local'"
                        id="States"
                        label="State"
                        label-cols-lg="2"
                        label-cols-sm="2"
                        label-for="type"
                    >
                      <multiselect v-model="state" :class="{ 'is-invalid':$v.state.$error }"
                                   :options="states" @blur="$v.state.$touch()"
                                   :custom-label="customSelector"
                                   @input="$v.state.$touch()"
                                   track-by="id" >

                      </multiselect>
                      <div v-if="$v.state.$error" class="invalid-feedback">
                        <span v-if="!$v.state.required">Please select a state.</span>
                      </div>
                    </b-form-group>

                    <b-form-group
                        v-if="location.text === 'Foreign'"
                        id="country"
                        label="Country"
                        label-cols-lg="2"
                        label-cols-sm="2"
                        label-for="type"
                    >
                      <multiselect v-model="country" :class="{ 'is-invalid':$v.country.$error }"
                                   :options="countries" @blur="$v.country.$touch()"
                                   :custom-label="customSelector"
                                   @input="$v.country.$touch()"
                                   track-by="id" >
                      </multiselect>
                      <div v-if="$v.country.$error" class="invalid-feedback">
                        <span v-if="!$v.country.required">Please select a country.</span>
                      </div>
                    </b-form-group>

                    <b-form-group
                        id="submit-btn"
                        label=""
                        label-cols-lg="2"
                        label-cols-sm="2"
                        label-for=""
                    >
                      <b-button v-if="!isBusy" class="w-lg" type="button" variant="primary" @click="saveChanges()">Save
                        Changes
                      </b-button>
                      <b-spinner v-else class="m-2" role="status" variant="primary"></b-spinner>


                    </b-form-group>

                  </form>
                </div>
              </div>
              <!-- end row -->
            </div>
          </div>
          <!-- end card -->
        </div>
        <div class="col-lg-1">
        </div>
      </div>

    </b-modal>

  </Layout>
</template>